module.exports = "https://web-assets-production.autolist.com/_next/static/images/be-in-the-know-es-3cae2da35376493363fcf1978121517e.png";